<div class="wrapper ">   
    <app-site-content-widget 
        [title]="'Annual grade for ' + siteName" 
        [showExportButton]="true"
        [briefDescription]="'This is the grade that we give to the beach every year.'"
        [tooltip]=" {heading : 'More about annual grading', target : '' }"
        [chartTitle]="''"
        (ExportDataClick)="onExportDataClicked()">
        <!-- attributes chart, table & keyupdates are select attributes for ng-content in app-site-content-widget -->
        <app-google-charts-column-chart chart 
            [chartOptions]="chartOptions" 
            [chartData]="chartDataView">
        </app-google-charts-column-chart>  
        
        <div class="nsw-table nsw-table--striped nsw-table--bordered" table
            [tabindex]="0" *ngIf="annualGradeData?.[0]?.length > 1">
            <table>    
                <thead style="display:none">
                    <tr>
                        <th></th>
                        <th [attr.colspan]="annualGradeData?.[0].length - 1"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td [class]="'nowrap-text '+ (0 === j ? 'left-aligned-text' : 'centre-aligned-text')" 
                            *ngFor="let item of annualGradeData?.[0]; let j = index">
                            {{annualGradeData?.[0]?.[j]}}
                        </td>
                    </tr> 
                    <tr>
                        <td [class]="'nowrap-text '+ (0 === j ? 'left-aligned-text' : 'centre-aligned-text')"
                            *ngFor="let item of annualGradeData?.[1]; let j = index">
                            {{annualGradeData?.[1]?.[j]}}
                        </td>
                    </tr>  
                </tbody>
            </table>
        </div>        
        
        <app-key-popup-widget description="More about annual grading" popupTitle="More about annual grading" keyupdates >            
            <app-key-annual-grade-trend-popup-content-widget title="More about annual grading"></app-key-annual-grade-trend-popup-content-widget>
        </app-key-popup-widget> 
       
    </app-site-content-widget> 
</div>

